import request from '@/utils/httpRequest'

export function saveTestRecord(data) {
    return request({
        url: '/app/business/testrecord/saveTestRecord',
        method: 'post',
        data
    })
}

export function list(param) {
    return request({
        url: '/app/business/testrecord/list',
        method: 'get',
        params: param
    })
}

export function info(id) {
    return request({
        url: '/app/business/testrecord/info/' + id,
        method: 'get'
    })
}

export function updateTestRecord(data) {
    return request({
        url: '/app/business/testrecord/updateTestRecord',
        method: 'post',
        data
    })
}

export function recordLook(id) {
    return request({
        url: '/app/business/testrecord/recordLook/' + id,
        method: 'get'
    })
}

export function probleminfo(probId) {
    return request({
        url: '/app/business/probleminfo/info/' + probId,
        method: 'get'
    })
}

export function updateClose(data) {
    return request({
        url: '/app/business/probleminfo/updateClose',
        method: 'post',
        data
    })
}

export function saveAgainTestRecord(data) {
    return request({
        url: '/app/business/testrecord/saveTestRecord',
        method: 'post',
        data
    })
}

export function getNextRecCode(data) {
    return request({
        url: '/app/business/testrecord/getNextRecCode',
        method: 'post',
        data
    })
}
